module.exports = __webpack_public_path__ + "img/logo.cc21ed38.png";